var map = {
	"./home/joinForm.js": 1125,
	"./layout/404.js": 1126,
	"./layout/join.js": 1127,
	"./member.js": 1128,
	"./model/browser.js": 1129,
	"./user/favoriteamc.js": 1130,
	"./user/forgotpassword.js": 1131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1124;


//////////////////
// WEBPACK FOOTER
// ./widget (\/|\\)(?!_)[\w\.\-\\]+\.js$
// module id = 1124
// module chunks = 4